export default "__VITE_ASSET__Toj9opCX__"